// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"09e62b3f","268":"121708b9","343":"b8a6eeb7","360":"4d7f1c9a","491":"d22dfce9","513":"deb515e7","559":"54934c60","732":"0d6b2718","960":"22bba652","979":"45eb027e"}[chunkId] + ".chunk.js";
};